import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import PDPAlertBar from 'components/consumer/PDP/PDPAlertBar';
import useSetPdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/useSetPdpSelectedCustomizerTab';
import { PDP_CUSTOMIZE_TAB_ID } from 'commons/constants';
import { PRODUCT_CONFIGURATION_INTERACTION, trackProductConfigurationInteracted } from 'data-hooks/useEvents/pdpInteractionEvents';
const PDPSelectionAlert = t0 => {
  const $ = _c(8);
  const {
    selectionValidity: t1
  } = t0;
  const selectionValidity = t1 === undefined ? "" : t1;
  const setPdpSelectedCustomizerTab = useSetPdpSelectedCustomizerTab();
  let t2;
  if ($[0] !== setPdpSelectedCustomizerTab) {
    t2 = () => {
      setPdpSelectedCustomizerTab(PDP_CUSTOMIZE_TAB_ID);
      trackProductConfigurationInteracted(PRODUCT_CONFIGURATION_INTERACTION.CUSTOMIZATION_SELECTED);
    };
    $[0] = setPdpSelectedCustomizerTab;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const goCustom = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span>Unavailable for ready to ship.</span>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== goCustom || $[4] !== selectionValidity) {
    t4 = selectionValidity === "invalid" ? <span> Get this by{" "}<button type="button" className="font-bold underline [background:none] border-0" onClick={goCustom}>going custom</button>.</span> : null;
    $[3] = goCustom;
    $[4] = selectionValidity;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <PDPAlertBar type="error">{t3}{t4}</PDPAlertBar>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
PDPSelectionAlert.propTypes = {
  selectionValidity: PropTypes.string
};
export default PDPSelectionAlert;